import { Record, Map } from 'immutable';

import { CurrentUser } from '../domain/current-user';
import { Features } from '../domain/features';
import { Organization } from '../domain/organization';

export const CORE = 'core';

export interface IAppRootState {
	[CORE]: CoreState;
}
interface ICoreState {
	selectedOrganization: number;
	organizationsForUser: Map<number, Organization>;
	currentUser: CurrentUser;
	features: Features;
}

const stateDefaults: ICoreState = {
	selectedOrganization: -1,
	organizationsForUser: Map(),
	currentUser: CurrentUser.build(),
	features: Features.build(),
};

export class CoreState extends Record<ICoreState>(stateDefaults) {
	public setSelectedOrganization(val: number): CoreState {
		return this.set('selectedOrganization', val);
	}

	public setCurrentUser(val: CurrentUser): CoreState {
		return this.set('currentUser', val);
	}

	public setOrganizationsForUser(val: Map<number, Organization>): CoreState {
		return this.set('organizationsForUser', val);
	}

	public setFeatures(val: Features): CoreState {
		return this.set('features', val);
	}
}
